/* @flow */

import Immutable from 'immutable';
import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { pureReducer } from '../util/pure_reducer';
import { history } from '../history';
import { datasetReducer } from './dataset_reducer';
import { loadingReducer } from './loading_reducer';
import { mapReducer } from './map_reducer';
import { notificationReducer } from './notification_reducer';
import { sidepanelReducer } from './sidepanel_reducer';
import { viewReducer } from './view_reducer';

var reducers = Immutable.Map({
  dataset: datasetReducer,
  loading: loadingReducer,
  map: mapReducer,
  notification: notificationReducer,
  sidepanel: sidepanelReducer,
  view: viewReducer,
  routing: routerReducer
});

const initialState = Immutable.Map();

const combinedReducer = pureReducer((rootState: Immutable.Map, action: Object) =>
  reducers.reduce(
    (state: Immutable.Map, reducer: Function, name: string) =>
      state.update(name, subState => reducer(subState, action)),
    rootState
  ));

const rootReducer = (rootState: Immutable.Map = initialState, action: Object) =>
  combinedReducer(rootState, action).set('_action', action);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
var store = composeEnhancers(
  applyMiddleware(thunk),
  applyMiddleware(routerMiddleware(history))
)(createStore)(rootReducer);

export { store };
